<section>
  <div class="max-w-screen-xl mx-auto flex flex-col lg:flex-row bg-[#020042]">
    <div class="w-full h-[20rem] py-12 px-6 sm:px-8 lg:px-14 font-extralight text-[#F2F4FE] bg-[#020042]">

      <h2 class="mb-6 mt-2 text-base tracking-wider uppercase">
        {{ 'newsletter.title' | translate }}
      </h2>

      <p class="mb-12 text-xs leading-loose">
        {{ 'newsletter.description' | translate }}
      </p>

      <!-- Thank you message with animation -->
      <div *ngIf="formSubmitted"
        class="text-xs text-[#F2F4FE] mt-4 p-3 bg-[#5173EF] rounded-md transition-opacity duration-300 ease-in-out">
        <p class="text-center font-semibold">{{ 'newsletter.thank_you_message' | translate }}</p>
      </div>

      <!-- Form -->
      <form *ngIf="!formSubmitted" [formGroup]="form" (ngSubmit)="onSubscribe()" class="flex flex-col">

        <!-- email -->
        <div class="relative w-full flex">
          <input type="email" formControlName="email" placeholder="{{ 'newsletter.placeholder' | translate }}"
            class="w-full h-10 px-4 text-gray-800 bg-gray-100 border border-[#5173EF] rounded-sm focus:outline-none focus:border-[#5173EF] focus:border-2 placeholder:text-[#020042] placeholder:text-xs placeholder:font-normal" />

          <button type="submit" [disabled]="form.invalid" aria-label="Enviar correo electrónico para suscripción"
            class="h-10 px-4 text-white bg-[#5173EF] rounded-r-sm hover:bg-blue-600 flex items-center justify-center cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed">
            <img src="../../../assets/img/send.png" alt="Ícono de enviar" class="h-6 w-6 object-contain"
              role="presentation" aria-hidden="true" />
          </button>
        </div>

        <!-- email validation -->
        <div *ngIf="email?.touched && email?.invalid" class="text-xs text-[#F2F4FE] mt-2">
          <div *ngIf="email?.errors?.['required']">{{ 'newsletter.email_required_error' | translate }}</div>
          <div *ngIf="email?.errors?.['email']">{{ 'newsletter.global_error_invalid_email' | translate }}</div>
        </div>

        <!-- terms -->
        <div class="mt-4">
          <label class="flex items-center text-xs text-gray-600">
            <input type="checkbox" formControlName="acceptedDisclaimer">
            <span class="ml-2 text-[#F2F4FE]">
              {{ 'newsletter.terms_label' | translate }}
              <a [routerLink]="['/terms-and-conditions']" fragment="terminos-anchor" class="underline" role="link">
                {{ 'newsletter.terms_link' | translate }}
              </a>
            </span>
          </label>

          <!-- terms error -->
          <div *ngIf="acceptedDisclaimer?.touched && acceptedDisclaimer?.invalid" class="text-xs text-[#F2F4FE] mt-2">
            {{ 'newsletter.terms_required_error' | translate }}
          </div>
        </div>

        <!--  general error  -->
        <div *ngIf="subscriptionEmailErrorKey" class="text-[#F2F4FE] text-xs mt-2 w-full text-left">
          {{ subscriptionEmailErrorKey | translate }}
        </div>

      </form>
    </div>
  </div>
</section>